import React from 'react';
import TwistPage from './components/TwistPage';

function App() {
    return (
        <div className="App">
            <TwistPage />
        </div>
    );
}

export default App;
